import React from 'react';

const Cooperation = {
    Odoro: 1,
    Medica: 2
}

const AppointmentCanceled = ({ declinedText, scheduleAppointmentUrl, cooperation }) => {
    let appointmentLink = null;
    if (cooperation && cooperation != Cooperation.Medica && scheduleAppointmentUrl) {
        appointmentLink = <div>
            <a href={scheduleAppointmentUrl} id="confirm_btn" className="btn text-white m-0">קביעת תור חדש</a>
        </div>;
    }

    return (
        <div className="container">
            <div id="confirmation_buttons" className="d-flex justify-content-center align-items-center flex-column">
                <div className="confirmationButtons_title">{declinedText}</div>
                {appointmentLink}
            </div>
        </div>
    );
}

export default AppointmentCanceled;